<div *ngIf="favouriteId>0">
  <span style="font-weight: 600">Favourite Name : {{favouriteName}} </span>
</div>
<div class="panel__content no-padding ScrollTop" style="background: white">
  <!-- SPINNER -->
  <div style="margin-left: 39%" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <!-- MAIN TABLE LAYOUT -->
  <div style="display: flex; align-items: flex-start; width: 100%" *ngIf="!loading">
    <!-- LEFT STICKY TABLE -->
    <table style="
        border-collapse: collapse;
        position: sticky;
        left: 0;
        z-index: 5;
        background: #fff;
        transform: rotateX(180deg)
      ">
      <!-- EMPTY HEADER SPACE -->
      <tr>
        <th
          style="  min-width: 150px;border: 1px solid #ddd;padding: 31px 12px; background: #e9ecef;; box-sizing: border-box;">
        </th>
      </tr>

      <!-- DYNAMIC LEFT LABELS -->
      <ng-container *ngFor="let cycleRow of NewList">
        <tr>
          <th class="ColumnCell"
            style="min-width: 150px;border: 1px solid #ddd;padding: 12px;text-align: left; white-space: nowrap;background: #fff;box-sizing: border-box; ">
            Location
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            Date Fitted
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            Date Removed
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            Hours
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            BCM
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            TON
          </th>
        </tr>

        <tr>
          <th class="ColumnCell" style="
              min-width: 150px;
              border: 1px solid #ddd;
              padding: 12px;
              text-align: left;
              white-space: nowrap;
              background: #fff;
              box-sizing: border-box;
            ">
            Cost
          </th>
        </tr>
      </ng-container>
    </table>

    <!-- RIGHT SIDE -->
    <div style="  overflow: auto;   width: 100%;      ">
      <table style="
          border-collapse: collapse;
          width: max-content;
          table-layout: fixed;
          transform: rotateX(180deg);
        ">
        <!-- DYNAMIC HEADERS -->
        <tr>
          <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
            <th class="ColumnCell"
              style="min-width: 150px; border: 1px solid #ddd;
                padding: 12px;white-space: nowrap;box-sizing: border-box; background: #e9ecef;vertical-align: middle; ">
              <a (click)="openImplementDetails(cycleInfo.implementId)" style="
                  min-width: 150px;
                  font-size: medium;
                  font-weight: bold;
                  text-decoration: underline;
                  cursor: pointer;
                " class="wraptext" matTooltip="{{ cycleInfo.serialNo }}">
                {{ cycleInfo.serialNo }}
              </a>

              <div style="min-width: 150px">
                {{ cycleInfo.status }}
              </div>
            </th>
          </ng-container>
        </tr>

        <!-- DYNAMIC ROW GROUPS -->
        <ng-container *ngFor="let cycleRow of NewList; let i = index">
          <!-- LOCATION -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell wraptext" matTooltip="{{ cycleInfo.CycleDetails?.[i]?.location }}" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.location != null ? 'visible' : 'hidden'">
                  {{
                  cycleInfo.CycleDetails?.[i]?.location === ''
                  ? 'Inventory'
                  : cycleInfo.CycleDetails?.[i]?.location
                  }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- DATE FITTED -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.Fitted_date != null ? 'visible' : 'hidden'">
                  {{
                  cycleInfo.CycleDetails?.[i]?.Fitted_date === ''
                  ? 'On Going'
                  : (cycleInfo.CycleDetails?.[i]?.Fitted_date | date:'dd-MMM-yyyy')
                  }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- DATE REMOVED -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.Removed_date !== null && cycleInfo.CycleDetails?.[i]?.Removed_date !== ' ' ? 'visible'    : 'hidden'">
                  {{
                  !cycleInfo.CycleDetails?.[i]?.Removed_date ||
                  cycleInfo.CycleDetails?.[i]?.Removed_date.trim() === ''
                  ? 'On Going'
                  : (cycleInfo.CycleDetails?.[i]?.Removed_date | date:'dd-MMM-yyyy')
                  }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- HOURS -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.TotalSMU != null ? 'visible' : 'hidden'">
                  {{ cycleInfo.CycleDetails?.[i]?.TotalSMU ?? '' }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- BCM -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.TotalBCM != 0 ? 'visible' : 'hidden'">
                  {{ cycleInfo.CycleDetails?.[i]?.TotalBCM ?? '' }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- TON -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.TotalTon != 0 ? 'visible' : 'hidden'">
                  {{ cycleInfo.CycleDetails?.[i]?.TotalTon ?? '' }}
                </span>
              </td>
            </ng-container>
          </tr>

          <!-- COST -->
          <tr>
            <ng-container *ngFor="let cycleInfo of ImpLocationHistory[0]">
              <td class="ColumnCell" style="
                  min-width: 150px;
                  border: 1px solid #ddd;
                  padding: 12px;
                  box-sizing: border-box;
                ">
                <span [style.visibility]="cycleInfo.CycleDetails?.[i]?.TotalCost != null && cycleInfo.CycleDetails?.[i]?.TotalCost != 0 ? 'visible' : 'hidden'">
                  {{ cycleInfo.CycleDetails?.[i]?.TotalCost ?? '' }}
                </span>
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </table>
    </div>
  </div>
</div>
